import { useNavigate } from "react-router-dom";
import PageHeader from "../../../Layout/PageHeader";
import { useState } from "react";
import Table, { Column } from "../../../Components/Tables/Table";
import {
  ArrowLeftRight,
  PlusCircle,
  ThreeDotsVertical,
} from "react-bootstrap-icons";
import { bommaintenanceoverview } from "../../../Data/testData";
import CommonConfirmationModal from "../../../Components/Modals/CommonConfirmationModal";
import CommonModal from "../../../Components/Modals/CommonModal";
import ImportLayout from "../../../Layout/ImportLayout";
import ExportLayout from "../../../Layout/ExportLayout";

const BomMaintenanceOverview = () => {
  const pageName = "Kitting";
  const navigation = useNavigate();
  const [showModalForImportAndExport, setShowModalForImportAndExport] =
    useState({
      importModal: false,
      exportModal: false,
    });

  console.log("hello", showModalForImportAndExport);

  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showRowClicked, setShowRowClicked] = useState(false);
  const handelDetailScreenAction = (data: any) => {};
  const handelInactiveAction = (data: any) => {};

  const [showconfModal, setShowconfModal] = useState(false);
  const handleconfShow = () => setShowconfModal(true);
  const handleconfClose = () => setShowconfModal(false);
  const onModalSubmit = (response: boolean) => {
    console.log(response);
    handleconfClose();
  };

  const handelDeleteAction = (data: any) => {
    setShowconfModal(true);
  };

  const handleRowClick = (data: any) => {
    if (!showRowClicked) {
      navigation(
        `/inventory/assembly/kitting/details/${data.bommaintenanceNum}`
      );
    }
  };

  const handleShow = () => setShow(!show);
  const closeDeleteKitModal = () => {
    setShowModal(false);
  };
  const onCurrentPageChange = (page: number) => {
    // Handle page change here if needed
    console.log("Page changed to:", page);
  };
  const columns: Column[] = [
    {
      name: "Item Code",
      selector: (row: { bommaintenanceNum: string }) => (
        <span
          onClick={() => handleRowClick(row)}
          className="cursor-pointer text-primary "
        >
          {row.bommaintenanceNum}
        </span>
      ),
      enableSorting: true,
    },
    {
      name: "Item Description",
      selector: (row: { description: string }) => (
        // row.description
        <span   title={row.description.length > 15 ? row.description : ""}>
        {row.description.length > 15
          ? `${row.description.slice(0, 15)}...`
          : row.description}
      </span>
      ),
    },
    {
      name: "Item Type",
      selector: (row: { itemType: string }) => row.itemType,
    },
    {
      name: "No. of Components",
      selector: (row: { noOfComponents: string }) => row.noOfComponents,
    },
    { name: "UOM", selector: (row: { uom: number }) => row.uom },
    {
      name: "Status",
      selector: (row: { status: string }) => {
        return row.status === "Active" ? (
          <span className="badge asn-overview-status asn-overview-status-border-blue">
            Active
          </span>
        ) : row.status === "Backorder" ? (
          <span className="badge text asn-overview-status asn-overview-status-border-red">
            Backorder
          </span>
        ) : row.status === "Completed" ? (
          <span className="badge asn-overview-status asn-overview-status-border-green">
            Completed
          </span>
        ) : (
          <></>
        );
      },
    },
    {
      name: (
        <>
          <ArrowLeftRight className="me-2" /> <PlusCircle />
        </>
      ),
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none list-ellipse-ms"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={() => setShowRowClicked(true)}
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handelDetailScreenAction(row)}
            >
              Edit
            </li>
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handelInactiveAction(row)}
            >
              Inactive
            </li>
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handelDeleteAction(row)}
            >
              Delete
            </li>
          </ul>
        </>
      ),
    },
  ];

  return (
    <>
      <PageHeader
        name="Configure Kit"
        isShowUpload={true}
        addUrl="/inventory/assembly/kitting/create"
        setShowModalForImportAndExport={setShowModalForImportAndExport}
        showModalForImportAndExport={showModalForImportAndExport}
      />
      <div className="clearfix"></div>
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div>
        <Table
          columns={columns}
          data={bommaintenanceoverview}
          pagination={{
            recordsPerPage: 15,
            totalRecords: bommaintenanceoverview.length,
            onCurrentPageChange: onCurrentPageChange,
          }}
          CheckboxStatus={true}
          enableSorting={true}
        />
      </div>
      <div className="inbound-CheckIn-Table-Main-Div"></div>
      <CommonModal
        show={showModalForImportAndExport.importModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, importModal: false };
        })}
        heading={"Import File"}
        content={<ImportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
      <CommonModal
        show={showModalForImportAndExport.exportModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, exportModal: false };
        })}
        heading={"Export"}
        content={<ExportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
      <CommonConfirmationModal
      customClassName="header-border"
        show={showconfModal}
        content={<> You are about to delete this  <br />
        Are you Sure? </>}
        onModalSubmit={onModalSubmit}
      />

    </>
  );
};

export default BomMaintenanceOverview;
